/**
 * 自动生成， 请不要手工修改！
 */

import {MessageType} from "../../MessageContentType";
import {Request} from "../../../datatype/request/Request";
import { TypeFactory } from "../../../serialize/TypeFactory";
import { GenericEntityMessage } from "@/services/message/entity/api/GenericEntityMessage";

export abstract class AbstractRequestMessage extends GenericEntityMessage<Request> {
    constructor() {
        super();
    }

    public getContentType(): MessageType {
        return MessageType.REQUEST;
    }

    public fillFromJson(json: Object, factory?: TypeFactory) {
        if (factory) {
            super.fillFromJson(json, factory);
        } else {
            super.fillFromJson(json);
        }
    }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "RequestMessage";
    }
  }

  public getTypeId(): string {
    return "RequestMessage";
  }

  public getClassName(): string {
    return "com.gong_wei.common.message.entity.request.RequestMessage";
  }
}
